import { render, staticRenderFns } from "./ElectricVehiclesConfigModal.vue?vue&type=template&id=5d789f9e"
import script from "./ElectricVehiclesConfigModal.vue?vue&type=script&lang=js"
export * from "./ElectricVehiclesConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ElectricVehiclesConfigModal.vue?vue&type=style&index=0&id=5d789f9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports